


























































import { Component, Watch } from 'vue-property-decorator';
import Loading from '@/components/loading.vue';
import { Route } from 'vue-router';
import 'bootstrap';
import 'bootstrap/scss/bootstrap.scss';
import { configuration } from '@/configuration';
import { IsAuthMixin } from '@step/auth';
import { NavbarCustomerSelection, NavbarCustomerSelectionCaptions, NavbarCustomerSelectionItem } from '@step/vue';
import { Popup } from '@/components';
import { DxToolbarItem } from 'devextreme-vue/popup';
import container, { apiService, authorizationService, customerService, localizationService } from './container';
import DxButton from 'devextreme-vue/button';


@Component({ components: { Loading, NavbarCustomerSelection, Popup, DxToolbarItem, DxButton } })
export default class App extends IsAuthMixin {
	private currentLayoutName = 'none';
	appLoading = false;
	showCustomerPopup = false;
	customers: NavbarCustomerSelectionItem[] = [];
	selectedCustomer: NavbarCustomerSelectionItem | null = null;
	get route(): Route {
		return this.$route;
	}

	reloadDashboard: () => Promise<void> = async () => void 0;
	navbarCustomerSelectionCaptions = new NavbarCustomerSelectionCaptions(this.$t('captions.Customer'), 'Company', 'Site');
	get currentLayout() {
		if (!this.appLoading && this.currentLayoutName)
			return () => import(`@/layouts/${this.currentLayoutName}/layout.vue`);
	}
	get getSelectBoxCaption() {
		return this.$t('popup.selectBoxText');
	}
	get hasLayout() {
		return !this.appLoading && !(this.currentLayoutName === 'none');
	}

	get initialCustomer() {
		return this.customers.find(c => c.Id === customerService.getCustomer());
	}

	get hasCustomer() {
		return !customerService.getCustomer();
	}

	get translationsLoaded() {
		return this.$store.state.step_localization.loadingLocaleSuccess || this.$store.state.step_localization.loadingLocaleFailure;
	}

	get langs() {
		return localizationService.loadedLanguages;
	}

	get inIframe() {
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}

	async onRejectClick() {
		this.showCustomerPopup = false;

	}

	async onAcceptClick() {
		await this.changeCustomer();
		this.showCustomerPopup = false;
		if (this.$router.currentRoute.path !== '/') {
			this.$router.push('/');
		}
	}

	onChangeCustomer() {
		this.showCustomerPopup = true;
	}

	async changeCustomer() {
		if (this.selectedCustomer !== null) {
			const customer = this.customers.find(c => c === this.selectedCustomer);
			if (customer !== undefined)
				customerService.setCustomer(this.selectedCustomer.Id, customer.Name);
		}
		// container.downloadLocale();
		const user = authorizationService.getCurrentUser();
		localizationService.reloadLocale(user.languageCode);
		this.reloadDashboard();
	}

	async onCustomerChanged(id: string) {
		if (this.selectedCustomer !== null) {
			this.selectedCustomer.Id = id;
		}
	}

	async loadCustomers() {
		const app = 'Dashboard';
		const userCustomers = await apiService.post<ICustomerItem[]>('customer', 'userCustomers', { App: app },
			{
				axiosConfig: {
					baseURL: configuration.authBackendBaseUrl
				}
			});
		this.customers = userCustomers.map<NavbarCustomerSelectionItem>(c => new NavbarCustomerSelectionItem(c.BusinessName, c.Id));
		if (this.customers.length === 1) {
			this.selectedCustomer = this.customers[0];
			customerService.setCustomer(this.selectedCustomer.Id, this.selectedCustomer.Name);
		}
		else if (!customerService.isCustomerSet) {
			this.showCustomerPopup = true;
		}


	}

	async created(): Promise<void> {
		await this.loadCustomers();
	}


	@Watch('route')
	private async onCurrentRouteChanged(route: Route) {
		if (this.customers.length === 0)
			await this.loadCustomers();

		this.currentLayoutName = (route.meta) && (route.meta.layout)
			? route.meta.layout
			: configuration.defaultLayout;
	}
}

interface ICustomerItem {
	Id: string;
	BusinessName: string;
}
